import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminMessagingService {
  constructor(private http: HttpClient) { }

    sendMessageToVisitor(payload: any) {
        return this.http.post(`${environment.baseUrl}twilio-conversation/send-admin-message-to-visitor`, payload);
    }
}